import { InvoiceOutgoingEditFormValues, InvoiceOutgoingItemEditFormValues, InvoiceOutgoingSearchFormValues, InvoiceRentEditFormValues } from "./types";

export const InvoiceStatusId = {
  Draft: "draft",
  Created: "created",
  Fiscalized: "fiscalized",
  Sent: "sent",
  Paid: "paid",
  Cancelled: "cancelled",
} as const;

export type InvoiceStatusIdType = typeof InvoiceStatusId[keyof typeof InvoiceStatusId];

/** Status e-računa kod providera — mora odgovarati `EInvoiceManager` na backendu. */
export const EInvoiceStatus = {
  Sending: "sending",
  Sent: "sent",
  Confirmed: "confirmed",
  Error: "error",
} as const;

/** Fiskalizacija 2.0 (B2B/B2G) — račun ide Poreznoj kao eRačun. */
export const FISCALIZATION_VERSION_EINVOICE = 2;

/**
 * Je li eRačun predan Poreznoj: provider mu je dodijelio svoj id, a zadnji pokušaj nije
 * završio greškom. Od tog trenutka račun se više ne može mijenjati i tek tada postoji XML —
 * isti uvjet vrijedi na backendu (`UpdateInvoice`, `GetInvoiceXml`).
 *
 * Ne miješati sa statusom računa `sent`, koji znači da je račun poslan kupcu mailom.
 */
export const isEInvoiceSent = (invoice: {
  fiscalizationVersion: number | null;
  fiscalizationStatus: string | null;
  providerExternalId: string | null;
}): boolean =>
  invoice.fiscalizationVersion === FISCALIZATION_VERSION_EINVOICE &&
  !!invoice.providerExternalId &&
  invoice.fiscalizationStatus !== EInvoiceStatus.Error;

export const initialFleetVehicleInvoiceEditForm: InvoiceOutgoingEditFormValues =
{
  invoiceNumber: null,
  contractSaleId: null,
  contractRentId: null,
  invoiceStatusId: null,
  vehicleId: null,
  contactClientId: null,
  invoiceDate: new Date(),
  dueDate: null,
  durationDays: null,
  taxRate: 25,
  taxTypeId: null,
  taxExemptionReasonId: null,
  items: [],
  buyerTypeId: null,
  paymentMethodId: null,
  paymentIBAN: null,
  deliveryDate: null,
  buyerName: null,
  buyerAddress: null,
  buyerOIB: null,
  buyerVAT: null,
  buyerCountryId: null,
  note: null,
  internalNote: null,
  currencyId: "eur",
  exchangeRate: null,
  languageId: "hr",
  fiscalizationRequired: false,
  fiscalizationVersion: null,
  fiscalizationStatus: null,
  fiscalizationJIR: null,
  fiscalizationZKI: null,
  fiscalizationErrorMessage: null,
  providerExternalId: null,
  emailSentAt: null,
  emailSentTo: null,
};

export const initialFleetVehicleInvoiceItemEditForm: InvoiceOutgoingItemEditFormValues =
{
  id: crypto.randomUUID(),
  code: null,
  name: null,
  taxRate: 25,
  quantity: 1,
  priceWithoutTax: null,
  priceWithTax: null,
  discountAmount: null,
  discountTypeId: "PERCENTAGE",
  total: null,
  note: null,
  kpdCode: null,
  unitOfMeasureId: null,
  discountPercent: null,
  billingItemTypeId: null,
};

export const initialFleetVehicleInvoiceSearchForm: InvoiceOutgoingSearchFormValues =
{
  search: null,
  invoiceStatusId: null,
  invoiceDateFrom: null,
  invoiceDateTo: null,
  dueDateFrom: null,
  dueDateTo: null,
  totalMin: null,
  totalMax: null,
  contactClientId: null,
};

export const initialFleetVehicleInvoiceRentEditForm: InvoiceRentEditFormValues =
{
  invoiceNumber: null,
  invoiceOutgoingTypeId: "rent",
  contractRentId: null,
  invoiceStatusId: null,
  vehicleId: null,
  contactClientId: null,
  invoiceDate: new Date(),
  dueDate: null,
  durationDays: null,
  taxRate: 25,
  taxTypeId: null,
  taxExemptionReasonId: null,
  items: [],
  paymentMethodId: null,
  paymentIBAN: null,
  deliveryDate: null,
  renterName: null,
  renterAddress: null,
  renterOIB: null,
  renterVAT: null,
  renterCountryId: null,
  note: null,
  internalNote: null,
  currencyId: "eur",
  exchangeRate: null,
  languageId: "hr",
  fiscalizationRequired: false,
  fiscalizationVersion: null,
  fiscalizationStatus: null,
  fiscalizationJIR: null,
  fiscalizationZKI: null,
  fiscalizationErrorMessage: null,
  providerExternalId: null,
};
